/**
 * Table column scopes
 */
export const ORGANIZATION = 'organization';
export const ACCOUNT = 'account';
export const CONTACT = 'contact';
export const PIPELINE = 'pipeline';
export const PRODUCT = 'product';
export const ENTITY_CONTACT = 'entity-contact';
export const ENTITY_PROFILE = 'entity-profile';
